import React from 'react'
import styled from '@emotion/styled'
import ThemeConsumer from '@/hoc/ThemeConsumer'
import { layouts, fonts } from '@/utils/preset'
import { tablet, mobile, mobileS } from '@/utils/media'
import { mq, rem } from '@/utils/helpers'
import LogoV from '@/components/svg/LogoV'

const Footer = ({ theme }) => (
  <Root theme={theme}>
    <Main>
      <Container>
        <Left><Logo /></Left>
        <Right>
          <Table>
            <tbody>
              <Row>
                <Row_Head>会社名</Row_Head>
                <Row_Detail><a href="https://frontvision-consulting.com" rel="noopener noreferrer" target="_blank">株式会社フロントビジョン </a></Row_Detail>
              </Row>
              <Row>
                <Row_Head>所在地</Row_Head>
                <Row_Detail>〒192-0063<br />東京都八王子市元横山町3-9-3 </Row_Detail>
              </Row>
              <Row>
                <Row_Head>電話番号</Row_Head>
                <Row_Detail><a href="tel:050-5534-6826">050-5534-6826</a></Row_Detail>
              </Row>
            </tbody>
          </Table>
        </Right>
      </Container>
    </Main>
    <Foot theme={theme}>
      <CopyRight theme={theme}>
        <CopyRight_Container>Copyright © 2020 FRONTVISION All rights reserved.</CopyRight_Container>
      </CopyRight>
    </Foot>
  </Root>
)

const Root = styled.div`
`

const Main = styled.div`
  padding: ${rem(56)} ${rem(40)};
  @media ${mq.and(tablet)} {
    padding: ${rem(56)} ${rem(layouts.defs.pad.tablet)};
  }
  @media ${mq.and(mobile)} {
    padding: ${rem(32)} ${rem(layouts.defs.pad.mobile)};
  }
`

const Container = styled.div`
  display: flex;
  align-items: center;
  max-width: ${rem(layouts.defs.contentMaxWidth.small)};
  margin: 0 auto;
  justify-content: center;
`

const Left = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
`

const Logo = styled(LogoV)`
  width: ${rem(83)};
  @media ${mq.and(mobile)} {
    width: ${rem(60)};
  }
  @media ${mq.and(mobileS)} {
    width: ${rem(52)};
  }
`

const Table = styled.table``

const Row = styled.tr`
  text-align: left;
`

const Row_Head = styled.th`
  font-size: ${rem(12)};
  font-weight: 700;
  padding: ${rem(7)} 0;
  @media ${mq.and(mobile)} {
    padding: ${rem(4)} 0;
  }
  @media ${mq.and(mobileS)} {
    font-size: ${rem(11)};
    white-space: nowrap;
  }
`

const Row_Detail = styled.td`
  padding: ${rem(7)} 0;
  padding-left: ${rem(28)};
  font-size: ${rem(12)};
  line-height: 1.5;

  a {
    text-decoration: underline;
  }

  @media ${mq.and(mobile)} {
    padding: ${rem(4)} 0;
    padding-left: ${rem(16)};
  }

  @media ${mq.and(mobileS)} {
    font-size: ${rem(11)};
    padding-left: ${rem(12)};
  }
`

const Right = styled.div`
  padding-left: ${rem(50)};
  @media ${mq.and(mobile)} {
    padding-left: ${rem(24)};
  }
`

const Foot = styled.div`
  background-color: ${props => props.theme.text.base};
  color: ${props => props.theme.text.contrast.base};
`

const CopyRight = styled(layouts.components.FullWidth)`
`

const CopyRight_Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${rem(48)};
  font-size: ${rem(12)};
  font-family: ${fonts.en};
`

export default ThemeConsumer(Footer)
